
















































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import axios, { resHandle } from "@/plugins/axios";
import { GetOssParams } from "@/request/cdr";
import * as OSS from "ali-oss";
import Jiatingzhuzhi from "./custom-contents/jiatingzhuzhi.vue";
import Zhusu from "./custom-contents/zhusu.vue";
import Xianbingshi from "./custom-contents/xianbingshi.vue";
import Zhongyaoyinpian from "./custom-contents/zhongyaoyinpian.vue";
import Qitayongyao from "./custom-contents/qitayongyao.vue";
import Wenjian from "./custom-contents/wenjian.vue";
@Component({
  components: {
    Jiatingzhuzhi,
    Zhusu,
    Xianbingshi,
    Zhongyaoyinpian,
    Qitayongyao,
    Wenjian,
  },
})
export default class CustomContentTransfer extends Vue {
  @Prop()
  private index: any;
  @Prop()
  private content: any;
  private resultOptions: any[] = [];
  private ossReady: boolean = false;
  private get ossClient() {
    return this.$store.state.ossClient;
  }
  @Watch("content.type", { immediate: true })
  private contentTypeChange(type) {
    if (this.content["type"] === "搜索多选") {
      this.$nextTick().then(() => {
        this.resultOptions = this.content.value;
      });
    }
    if (this.content["type"] === "文件") {
      // if (!this.ossClient.options) {
      //   this.createOss().then(() => {
      //     this.ossReady = true;
      //   });
      // } else {
      //   this.ossReady = true;
      // }
    }
  }
  /**
   * @description 获取store中的可编辑状态
   */
  private get composeDisabled() {
    return this.$store.state.researchListComposeDiabled;
  }
  /**
   * @description content双向绑定
   */
  private contentChange() {
    this.$emit("update:content", this.content);
  }
  /**
   * @description 计分单选选择
   */
  private radioSelectThis(option, parent) {
    parent["value"] = option;
  }
  /**
   * @description 搜索
   */
  private fetchOptions(ev) {
    let searchType: string = this.content["title"];
    if (searchType === "伴随症状") {
      searchType = "中医症状";
    }
    const params: any = {
      params: {
        type: searchType,
        search: ev,
      },
    };
    axios.get("api/project/terms", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.resultOptions = data.data.concat(this.content.value);
      });
    });
  }
  /**
   * @description 创建oss
   */
  private createOss() {
    return new Promise((resolve, reject) => {
      GetOssParams(this).then((data: any) => {
        const client = new OSS({
          accessKeyId: data.Credentials.AccessKeyId,
          accessKeySecret: data.Credentials.AccessKeySecret,
          stsToken: data.Credentials.SecurityToken,
          endpoint: data.endpoint,
          bucket: data.bucket,
        });
        this.$store.commit("updateOss", client);
        resolve();
      });
    });
  }
}
